import React, { useEffect, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";
import { isMuted, toggleMuted, subscribeMute, playSoftClick } from "../lib/sound";

export const MuteToggle = ({ className = "" }) => {
  const [muted, setMuted] = useState(isMuted());
  useEffect(() => subscribeMute(setMuted), []);

  const onClick = () => {
    playSoftClick();
    toggleMuted();
  };

  return (
    <button
      onClick={onClick}
      data-testid="mute-toggle"
      aria-label={muted ? "Unmute" : "Mute"}
      title={muted ? "Sound off" : "Sound on"}
      className={`btn-brutal-press bg-white text-[#111111] border-4 border-[#111111] shadow-brutal-sm w-11 h-11 flex items-center justify-center ${className}`}
    >
      {muted ? <VolumeX size={20} /> : <Volume2 size={20} />}
    </button>
  );
};
